export default "__VITE_ASSET__DPDKYYo3__"